export default __webpack_public_path__ + "static/media/bandeau-catalogue-tablette-es.e3b89495.png";